import React from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { Foldable } from '@crossroads/ui-components';
import { Box, BoxHeader, BoxBody } from '../Box/index.js';
import { ChevronBigSvg } from '../../icons/index.js';
import styles from 'shop-views/CartSummary.scss';

/* eslint-disable react/boolean-prop-naming */
var CartSummary = _ref => {
  var children = _ref.children,
      open = _ref.open,
      setOpen = _ref.setOpen,
      className = _ref.className,
      quoteData = _ref.quoteData,
      formatPrice = _ref.formatPrice,
      formatPoints = _ref.formatPoints;
  var t = useTranslate();

  if (!quoteData.data) {
    return null;
  }

  var _quoteData$data = quoteData.data,
      shipping = _quoteData$data.shipping,
      isVirtual = _quoteData$data.isVirtual,
      selectedPointPayment = _quoteData$data.selectedPointPayment,
      discountTotal = _quoteData$data.discountTotal;
  var grandTotal = quoteData.data.grandTotal.incVat;
  var subTotal = quoteData.data.subTotal.incVat;

  var toggleOpen = () => setOpen(!open);

  var shippingCost = (shipping == null ? void 0 : shipping.total.incVat) || 0;
  var showShippingInfo = shippingCost > 0.01;
  var partPaymentAvailable = selectedPointPayment ? selectedPointPayment.currency.max.incVat !== 0 : false;
  var showDistribution = selectedPointPayment ? partPaymentAvailable && selectedPointPayment.points.value.exVat > 0 && selectedPointPayment.currency.remaining.incVat > 0 : false;
  var isPointsPayment = selectedPointPayment !== null && selectedPointPayment !== undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.block, {
      [styles.open]: open,
      [styles.processing]: quoteData.state === "UPDATING_ITEM"
    }, className)
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(BoxHeader, {
    className: styles.header,
    onClick: toggleOpen
  }, /*#__PURE__*/React.createElement("span", null, open ? t("CART.MINIMIZE_SUMMARY") : t("CART.VIEW_DETAILS")), /*#__PURE__*/React.createElement("img", {
    src: ChevronBigSvg,
    className: styles.closeIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React.createElement(Foldable, {
    open: open
  }, /*#__PURE__*/React.createElement(BoxBody, null, /*#__PURE__*/React.createElement("h4", null, t("CART.SUMMARY")), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, !isPointsPayment && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, t("CART.SUBTOTAL")), /*#__PURE__*/React.createElement("td", null, formatPrice(subTotal))), isPointsPayment && formatPoints && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, t("CART.PRODUCTS")), /*#__PURE__*/React.createElement("td", null, formatPoints(selectedPointPayment.points.value.exVat)))), !isVirtual && shipping && shipping.method && showShippingInfo && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("CART.SHIPPING")), /*#__PURE__*/React.createElement("td", null, formatPrice(shipping.total.incVat))), discountTotal < -0.01 && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("CART.DISCOUNT")), /*#__PURE__*/React.createElement("td", null, formatPrice(discountTotal))), showDistribution && isPointsPayment && formatPoints && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: styles.tableSection
  }, t("CHECKOUT.PAYMENT_DISTRIBUTION")), /*#__PURE__*/React.createElement("td", {
    className: styles.tableSection
  }, /*#__PURE__*/React.createElement("span", null, formatPoints(selectedPointPayment.points.selected.exVat)), partPaymentAvailable && selectedPointPayment.currency.remaining.incVat >= 0.01 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), t("CHECKOUT.AND"), "\xA0", /*#__PURE__*/React.createElement("span", null, formatPrice(selectedPointPayment.currency.remaining.incVat))))))), open && /*#__PURE__*/React.createElement("div", {
    className: styles.innerSeparator
  }), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, !isPointsPayment && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: styles.tableSection
  }, /*#__PURE__*/React.createElement("strong", null, t("CART.GRANDTOTAL"))), /*#__PURE__*/React.createElement("td", {
    className: styles.tableSection
  }, formatPrice(grandTotal))), isPointsPayment && formatPoints && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("h3", {
    className: styles.heading
  }, t("CHECKOUT.AMOUNT_TO_PAY"))), /*#__PURE__*/React.createElement("td", {
    className: styles.totalRow
  }, selectedPointPayment.points.selected.exVat > 0 && /*#__PURE__*/React.createElement("span", null, formatPoints(selectedPointPayment.points.selected.exVat)), !partPaymentAvailable && selectedPointPayment.points.selected.exVat <= 0 && /*#__PURE__*/React.createElement("span", null, formatPoints(selectedPointPayment.points.max.exVat)), partPaymentAvailable && selectedPointPayment.currency.remaining.incVat > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, selectedPointPayment.points.selected.exVat > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), t("CHECKOUT.AND"), "\xA0"), /*#__PURE__*/React.createElement("span", null, formatPrice(selectedPointPayment.currency.remaining.incVat)))))))), /*#__PURE__*/React.createElement("div", {
    className: styles.separator
  }))), children));
};

export { CartSummary };
//# sourceMappingURL=index.js.map
